export default __webpack_public_path__ + "static/media/qr-framework.4789bcdb.svg";